import { Controller } from "@hotwired/stimulus"

// notifications-skeleton
// ---------------------------------------------------------------
// Shows a ghost skeleton over the notifications list while a filter-tab
// frame visit is in flight, then clears it when the content frame renders.
//
// Triggered EXPLICITLY by the tab links (click->notifications-skeleton#show)
// and cleared on the bubbling turbo:frame-render from the
// notifications_content frame. Scoped this way on purpose: mark-as-read
// (button_to) and load-more (turbo-stream append) fetches are NOT frame
// navigations and never call #show, so they don't flash the skeleton.
// ---------------------------------------------------------------
export default class extends Controller {
  static targets = ["skeleton", "frame"]

  connect() {
    this.onFrameRender = () => this.reset()
    this.element.addEventListener("turbo:frame-render", this.onFrameRender)
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-render", this.onFrameRender)
  }

  // Tab tapped — swap the live list out for the shimmer immediately, before
  // the network request even starts.
  show() {
    this.frameTarget.classList.add("hidden")
    this.skeletonTarget.classList.remove("hidden")
  }

  // Fresh content rendered into the frame — restore the list.
  reset() {
    this.skeletonTarget.classList.add("hidden")
    this.frameTarget.classList.remove("hidden")
  }
}
